import reportService from "../services/reportService";

export const GET_EXCEL_ORDER = "GET_EXCEL_ORDER";
export const GET_EXCEL_ORDER_SUCCESS = "GET_EXCEL_ORDER_SUCCESS";
export const GET_EXCEL_ORDER_ERROR = "GET_EXCEL_ORDER_ERROR";

export const GET_ORDER_INVOICE_LIST = "GET_ORDER_INVOICE_LIST";
export const GET_ORDER_INVOICE_LIST_SUCCESS = "GET_ORDER_INVOICE_LIST_SUCCESS";
export const GET_ORDER_INVOICE_LIST_ERROR = "GET_ORDER_INVOICE_LIST_ERROR";

export const GET_PURCHASE_ORDER_REPORT = "GET_PURCHASE_ORDER_REPORT";
export const GET_PURCHASE_ORDER_REPORT_SUCCESS =
  "GET_PURCHASE_ORDER_REPORT_SUCCESS";
export const GET_PURCHASE_ORDER_REPORT_ERROR =
  "GET_PURCHASE_ORDER_REPORT_ERROR";

export const GET_ORDER_SUMMARY_REPORT = "GET_ORDER_SUMMARY_REPORT";
export const GET_ORDER_SUMMARY_REPORT_SUCCESS =
  "GET_ORDER_SUMMARY_REPORT_SUCCESS";
export const GET_ORDER_SUMMARY_REPORT_ERROR = "GET_ORDER_SUMMARY_REPORT_ERROR";

export const GET_STYLE_WISE_ORDER_SUMMARY_REPORT =
  "GET_STYLE_WISE_ORDER_SUMMARY_REPORT";
export const GET_STYLE_WISE_ORDER_SUMMARY_REPORT_SUCCESS =
  "GET_STYLE_WISE_ORDER_SUMMARY_REPORT_SUCCESS";
export const GET_STYLE_WISE_ORDER_SUMMARY_REPORT_ERROR =
  "GET_STYLE_WISE_ORDER_SUMMARY_REPORT_ERROR";

export const GET_CASH_DISTRIBUTION_REPORT = "GET_CASH_DISTRIBUTION_REPORT";
export const GET_CASH_DISTRIBUTION_REPORT_SUCCESS =
  "GET_CASH_DISTRIBUTION_REPORT_SUCCESS";
export const GET_CASH_DISTRIBUTION_REPORT_ERROR =
  "GET_CASH_DISTRIBUTION_REPORT_ERROR";

// Order Report start
export function getExcelOrderRecord(
  startDate,
  endDate,
  sku,
  paymentMethod,
  paymentStatus,
  orderSource,
  orderStatus,
  shopId,
  categoryId
) {
  return async (dispatch) => {
    dispatch(getExcelOrder());
    return await reportService
      .getExcelOrder(
        startDate,
        endDate,
        sku,
        paymentMethod,
        paymentStatus,
        orderSource,
        orderStatus,
        shopId,
        categoryId
      )

      .then((response) => dispatch(getExcelOrderSuccess(response)))
      .catch((error) => dispatch(getExcelOrderError(error)));
  };
}

export function getExcelOrder() {
  return {
    type: GET_EXCEL_ORDER,
  };
}

export function getExcelOrderSuccess(success) {
  return {
    type: GET_EXCEL_ORDER_SUCCESS,
    payload: { success },
  };
}

export function getExcelOrderError(error) {
  return {
    type: GET_EXCEL_ORDER_ERROR,
    payload: { error },
  };
}
// Order Report End

// Order Invoice List Report start
export function getOrderInvoiceListRecord(query) {
  return async (dispatch) => {
    dispatch(getOrderInvoiceList());
    return await reportService
      .getOrderInvoiceList(query)
      .then((response) => dispatch(getOrderInvoiceListSuccess(response)))
      .catch((error) => dispatch(getOrderInvoiceListError(error)));
  };
}

export function getOrderInvoiceList() {
  return {
    type: GET_ORDER_INVOICE_LIST,
  };
}

export function getOrderInvoiceListSuccess(success) {
  return {
    type: GET_ORDER_INVOICE_LIST_SUCCESS,
    payload: { success },
  };
}

export function getOrderInvoiceListError(error) {
  return {
    type: GET_ORDER_INVOICE_LIST_ERROR,
    payload: { error },
  };
}
// Order Invoice List Report End

// Purchase Order Report start
export function getPOReportRecord(query) {
  return async (dispatch) => {
    dispatch(getPOReport());
    return await reportService
      .getPOReport(query)

      .then((response) => dispatch(getPOReportSuccess(response)))
      .catch((error) => dispatch(getPOReportError(error)));
  };
}

export function getPOReport() {
  return {
    type: GET_PURCHASE_ORDER_REPORT,
  };
}

export function getPOReportSuccess(success) {
  return {
    type: GET_PURCHASE_ORDER_REPORT_SUCCESS,
    payload: { success },
  };
}

export function getPOReportError(error) {
  return {
    type: GET_PURCHASE_ORDER_REPORT_ERROR,
    payload: { error },
  };
}
// Purchase Order Report End

// Vendor-Wise Order Summary Report start
export function getOrderSummaryReportRecord(query) {
  return async (dispatch) => {
    dispatch(getOrderSummaryReport());
    return await reportService
      .getOrderSummaryReport(query)

      .then((response) => dispatch(getOrderSummaryReportSuccess(response)))
      .catch((error) => dispatch(getOrderSummaryReportError(error)));
  };
}

export function getOrderSummaryReport() {
  return {
    type: GET_ORDER_SUMMARY_REPORT,
  };
}

export function getOrderSummaryReportSuccess(success) {
  return {
    type: GET_ORDER_SUMMARY_REPORT_SUCCESS,
    payload: { success },
  };
}

export function getOrderSummaryReportError(error) {
  return {
    type: GET_ORDER_SUMMARY_REPORT_ERROR,
    payload: { error },
  };
}
// Vendor-Wise Order Summary Report End

// Style-Wise Order Summary Report start
export function getStyleWiseOrderSummaryReportRecord(query) {
  return async (dispatch) => {
    dispatch(getStyleWiseOrderSummaryReport());
    return await reportService
      .getStyleWiseOrderSummaryReport(query)

      .then((response) =>
        dispatch(getStyleWiseOrderSummaryReportSuccess(response))
      )
      .catch((error) => dispatch(getStyleWiseOrderSummaryReportError(error)));
  };
}

export function getStyleWiseOrderSummaryReport() {
  return {
    type: GET_STYLE_WISE_ORDER_SUMMARY_REPORT,
  };
}

export function getStyleWiseOrderSummaryReportSuccess(success) {
  return {
    type: GET_STYLE_WISE_ORDER_SUMMARY_REPORT_SUCCESS,
    payload: { success },
  };
}

export function getStyleWiseOrderSummaryReportError(error) {
  return {
    type: GET_STYLE_WISE_ORDER_SUMMARY_REPORT_ERROR,
    payload: { error },
  };
}
// Style-Wise Order Summary Report End

// Vendor Cash Distribution Report start
export function getCashDistributionReportRecord(query) {
  return async (dispatch) => {
    dispatch(getCashDistributionReport());
    return await reportService
      .getCashDistributionReport(query)

      .then((response) => dispatch(getCashDistributionReportSuccess(response)))
      .catch((error) => dispatch(getCashDistributionReportError(error)));
  };
}

export function getCashDistributionReport() {
  return {
    type: GET_CASH_DISTRIBUTION_REPORT,
  };
}

export function getCashDistributionReportSuccess(success) {
  return {
    type: GET_CASH_DISTRIBUTION_REPORT_SUCCESS,
    payload: { success },
  };
}

export function getCashDistributionReportError(error) {
  return {
    type: GET_CASH_DISTRIBUTION_REPORT_ERROR,
    payload: { error },
  };
}
// Vendor Cash Distribution Report End
